import React from "react";
import { motion } from "framer-motion";
import { useSiteContent } from "@/lib/site-content";

const Logo = ({ size = 44, className = "", showWordmark = true }) => {
  const { images } = useSiteContent();
  return (
    <motion.div
      className={`flex items-center gap-3 ${className}`}
      initial={{ opacity: 0, x: -8 }}
      animate={{ opacity: 1, x: 0 }}
      transition={{ duration: 0.5 }}
      data-testid="brand-logo"
    >
      {images.logo ? (
        <img
          src={images.logo}
          alt="Tobias Nunner – NNR Coaching"
          width={size}
          height={size}
          style={{
            width: size,
            height: "auto",
            maxHeight: size,
            objectFit: "contain",
            display: "block",
          }}
          loading="eager"
          decoding="async"
          draggable={false}
        />
      ) : (
        <picture>
          <source srcSet="/brand/logo-white.png" media="(min-resolution: 1.5dppx)" />
          <img
            src="/brand/logo-white-1200.png"
            alt="Tobias Nunner – NNR Coaching"
            width={size}
            height={size}
            style={{
              width: size,
              height: "auto",
              maxHeight: size,
              objectFit: "contain",
              display: "block",
            }}
            loading="eager"
            decoding="async"
            draggable={false}
          />
        </picture>
      )}
      {showWordmark && (
        <div className="leading-none hidden sm:block">
          <div className="font-display font-black text-[#F3F1E8] text-base sm:text-lg tracking-tight">
            TOBIAS NUNNER
          </div>
          <div className="text-[10px] sm:text-[11px] font-bold uppercase tracking-[0.28em] text-[#E8E5D0] mt-1.5">
            NNR Coaching
          </div>
        </div>
      )}
    </motion.div>
  );
};

export default Logo;
